import React from 'react';

const CarFilter = ({
  carMakes,
  carModels,
  carVariants,
  carColors,
  selectedMake,
  selectedModel,
  selectedVariant,
  selectedColor,
  handleMakeChange,
  handleModelChange,
  handleVariantChange,
  setSelectedColor
}) => {
  return (
    <div className='filterrow'>
      <select id="make" value={selectedMake} onChange={handleMakeChange}>
        <option value="">All Makes</option>
        {carMakes.map((make, index) => (
          <option key={make._id} value={make._id}>
            {make._id} ({make.count} cars)
          </option>
        ))}
      </select>

      <select id="model" value={selectedModel} onChange={handleModelChange}>
        <option value="">All Models</option>
        {carModels.map((model, index) => (
          <option key={index} value={model}>
            {model}
          </option>
        ))}
      </select>

      <select id="variant" value={selectedVariant} onChange={handleVariantChange}>
        <option value="">All Variants</option>
        {carVariants.map((variant, index) => (
          <option key={index} value={variant}>
            {variant}
          </option>
        ))}
      </select>

      <select id="color" value={selectedColor} onChange={(e) => setSelectedColor(e.target.value)}>
        <option value="">All Colors</option>
        {carColors.length > 0 ? (
          carColors.map((color, index) => (
            <option key={index} value={color}>
              {color}
            </option>
          ))
        ) : (
          <option disabled>No Colors Available</option>
        )}
      </select>
    </div>
  );
};

export default CarFilter;
